export const getAudienceForCallsToOWS = (requestUrl: string): string | undefined => {
    return requestUrl?.indexOf('/addison/') != -1
        ? 'api://155d75a8-799c-4ad4-ae3f-0084ccced5fa'
        : undefined;
};
